import { render } from "./SendPin.vue?vue&type=template&id=a98a4c84&ts=true"
import script from "./SendPin.vue?vue&type=script&lang=ts"
export * from "./SendPin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__